import React from 'react';
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin } from 'lucide-react';
import './Footer.css';
import logo from './logo.png'
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="grocery-footer">
      <div className="footer-content">
        <div className="footer-logo-section">
          <div className="footer-logo-container">
            <img
              src={logo}
              alt="Grocery Store Logo"
              className="footer-logo"
            />
          </div>
          <p className="footer-tagline">Fresh Groceries, Delivered with Care</p>
          <div className="social-icons">
            <a href="https://www.facebook.com/people/Shivneri-Fresh/100092166263098/" target='_blank' rel="noopener noreferrer" className="social-icon facebook">
              <Facebook />
            </a>
            <a href="https://www.instagram.com/shivneri.fresh/" target='_blank' rel="noopener noreferrer" className="social-icon instagram">
              <Instagram />
            </a>
            <a href="https://share.google/7yLh87XbUagQzVJEb" target='_blank' rel="noopener noreferrer" className="social-icon twitter">
              <Twitter />
            </a>
          </div>
        </div>

        <div className="footer-links-section">
          <div className="footer-column">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="/">Home</a></li>
              {/* <li><a href="/products">Products</a></li> */}
              {/* <li><a href="/deals">Special Deals</a></li> */}
              <li><a href="/about">About Us</a></li>
              <li><a href="/contact">Contact Us</a></li>
              <li><a href="/faq">FAQ</a></li>
            </ul>
          </div>

          {/* <div className="footer-column">
          <h3>Customer Service</h3>
          <ul>
          <li><a href="/contact">Contact Us</a></li>
          <li><a href="/shipping">Shipping</a></li>
          <li><a href="/returns">Returns</a></li>
          <li><a href="/faq">FAQ</a></li>
          </ul>
          </div> */}

          <div className="footer-column">
            <h3>Contact Info</h3>
            <ul>
              <li>
                <Phone size={16} />
                <span> +91 98673 78209</span>
              </li>
              <li>
                <Mail size={16} />
                <span>support@freshmart.com</span>
              </li>
              <li>
                <MapPin size={16} />
                <span>MAFCO MARKET, Sector 18, Vashi, Navi Mumbai</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2024 . All Rights Reserved.</p>
        <div className="footer-legal-links">
          <Link to="/privacy">Privacy Policy</Link>
          <a href="/terms">Terms of Service</a>
        </div>
      </div>
      <p className='designBy'><a href='http://twinklemediahub.com/' target='_blank' rel="noopener noreferrer" style={{ textDecoration: "none" }}>Designed by Twinkle Media Hub</a></p>
    </footer>
  );
};

export default Footer;